module.exports = __webpack_public_path__ + "static/media/train8.f85d078e.jpg";